import React, { useState } from "react";
import useCollapse from "react-collapsed";
import { Card, Button } from "react-bootstrap";

const PCB = () => {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse();

  return (
    <div className="subjectcards">
      <Card
        className="subject-card"
        style={{
          boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
          border: "6px solid #f272d9",
        }}
      >
        <div
          className="subject-card-header"
          style={{
            background: "#f73bbf",
            border: "6px solid #f272d9",
          }}
        >
          <p className="subject-card-heading">
            <b>Science (Medical)</b>
          </p>
        </div>
        <Card.Body className="subject-card-body">
          <div>
            <Card.Title>Compulsory Subjects</Card.Title>
            <Card.Body className="subject-card-section-body">
              <ul>
                <li>English</li>
                <li>Physics</li>
                <li>Chemistry</li>
                <li>Biology</li>
              </ul>
            </Card.Body>
          </div>
          <div {...getCollapseProps()}>
            <Card.Title>Optional Subjects</Card.Title>
            <Card.Body className="subject-card-section-body">
              <p className="subject-card-note">(Choose any one)</p>
              <ul>
                <li>Mathematics</li>
                <li>Computer Science</li>
                <li>Physical Education</li>
                <li>Painting</li>
              </ul>
              <p className="subject-card-note">(Choose any one)</p>
              <ul>
                <li>Tourism</li>
                <li>AI</li>
              </ul>
            </Card.Body>
          </div>
        </Card.Body>
        <Button
          className="subject-card-button"
          {...getToggleProps({
            onClick: () => setExpanded((prevExpanded) => !prevExpanded),
          })}
          style={{
            border: "none",
            backgroundColor: "#081b24",
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </Button>
      </Card>
    </div>
  );
};

export default PCB;
